module.exports = __webpack_public_path__ + "static/media/portfolio1.68590b0b.png";